import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type {
  Payload,
  SignupUserResponse,
} from '@jane/bloom/routes/_menu.$basename.signup/types';
import { buildFormData } from '@jane/bloom/utils/formData';

export const useSignup = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher<SignupUserResponse>();

  const signup = useCallback(
    (args: Payload) => {
      return fetcher.submit(buildFormData(args), {
        action: `${basename}signup`,
        method: 'post',
        preventScrollReset: true,
      });
    },
    [basename, fetcher]
  );

  return {
    fetcher,
    signup,
  };
};
